export default {
	apiKey: "AIzaSyDjZhmJre_p9nfe52t62bx-3_bPBZIdBj4",
	authDomain: "h-f-p-57524.firebaseapp.com",
	databaseURL: "https://h-f-p-57524-default-rtdb.europe-west1.firebasedatabase.app",
	projectId: "h-f-p-57524",
	storageBucket: "h-f-p-57524.appspot.com",
	messagingSenderId: "836962246430",
	appId: "1:836962246430:web:46c96b3fc920b4a493f30f"
}
